import type { MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSpacePath } from '../../../../hooks/useSpacePath';
import type { ReminderDatabase } from '../../../../types';
import { isPlainLeftClick } from '../../../../utils/isPlainLeftClick';
import useGetReminders from '../../../reminders/api/useGetReminders';

export function getReminderTargetPath(reminder: Pick<ReminderDatabase, 'subject_id' | 'provider_id'>): string | null {
  if (reminder.subject_id) {
    return `/topics/${reminder.subject_id}`;
  }
  if (reminder.provider_id) {
    return `/providers/${reminder.provider_id}/reminders`;
  }
  return null;
}

export function useRemindersSection() {
  // All non-completed reminders (expired + upcoming), ordered by due date ascending
  // so overdue ones appear first.
  const { data: reminders, isLoading } = useGetReminders({ is_completed: false });
  const navigate = useNavigate();
  const spacePath = useSpacePath();

  function getReminderHref(reminder: ReminderDatabase): string | undefined {
    const path = getReminderTargetPath(reminder);
    return path ? spacePath(path) : undefined;
  }

  function handleReminderClick(event: MouseEvent<HTMLElement>, href: string) {
    if (!isPlainLeftClick(event)) {
      return;
    }
    event.preventDefault();
    navigate(href);
  }

  return {
    items: reminders ?? [],
    isLoading,
    getReminderHref,
    handleReminderClick,
  };
}
